module.exports = __webpack_public_path__ + "static/img/bairenbaijiale.d3d5bfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/bairenbaijiale.jpg
// module id = RZzK
// module chunks = 0